/**
 *  @class
 *  @function ProductRecommendations
 */
class ProductRecommendations extends HTMLElement {
	constructor() {
		super();

		this.parent = this.closest('.product-recommendations--parent');

	}
	fetchProducts() {
		fetch(this.dataset.url)
			.then(response => response.text())
			.then(text => {
				const html = document.createElement('div');
				html.innerHTML = text;
				const recommendations = html.querySelector('product-recommendations');

				if (recommendations && recommendations.innerHTML.trim().length) {
					this.innerHTML = recommendations.innerHTML;

					if ( this.parent ) {
						this.parent.classList.add('product-recommendations--full');

						if ( document.body.classList.contains('open-cart')) {
							this.parent.classList.add('active');
						}
					}

				}

				this.classList.add('product-recommendations--loaded');

				// refresh slider to fix layout issues for mobile
				setTimeout(() => {
					this.initiateSlider();
				}
				, 400);
			})
			.catch(e => {
				console.error(e);
			});
	}
	connectedCallback() {
		this.fetchProducts();
		this.addToggleFunctionality();
	}

	addToggleFunctionality() {
		const toggleButtons = document.querySelectorAll('.product-recommendations__toggle-button');
		const sections = document.querySelectorAll('[data-section-name]');
	
		toggleButtons.forEach(button => {
			button.addEventListener('click', () => {
				toggleButtons.forEach(b => b.classList.remove('active'));
				button.classList.add('active');

				const target = button.getAttribute('data-target');
				sections.forEach(section => {
					section.classList.remove('is-active');
				});
				document.querySelector(`[data-section-name="${target}"]`).classList.add('is-active');

				if (target === 'product-recommendations__recommendations') {
					document.body.classList.add('x-hidden-desktop');
				} else {
					document.body.classList.remove('x-hidden-desktop');
				}

				window.dispatchEvent(new Event('resize'));

			});
		});
	}

	initiateSlider() {
		let args = {
			wrapAround: false,
			cellAlign: 'left',
			pageDots: false,
			contain: true,
			autoPlay: false,
			prevNextButtons: false,
			draggable: true,
			cellSelector: '.carousel__slide',
			adaptiveHeight: true,
			percentPosition: false,
		};

		const slider = this.querySelector('.complementary-products--inner .recommendation-slider-wrapper');

		if (slider) {
			const flkty = new Flickity(slider, args);
		}
	}
}

customElements.define('product-recommendations', ProductRecommendations);